import { CrewEventModel } from "../crews/scheduler-stores";
import EventHelperCommon from "./common";

import C from "../Constants";

/**
 * 下船中様態イベントモデルを新規作成する
 * @param {Date} startDate
 * @param {Date} endDate
 * @param {String} status_id
 * @param {String} crew_role_id
 * @returns {CrewEventModel}
 */
const newAshoreEvent = (startDate, endDate, status_id, crew_role_id) => {
  return new CrewEventModel({
    startDate: startDate,
    endDate: endDate,
    phantom_group_key: EventHelperCommon.genPhantomGroupKey(),
    enterprise_manning_status_id: status_id,
    enterprise_crew_role_id: crew_role_id,
    event_type: C.SCHEDULING_EVENT_TYPE.ASHORE,
    scheduling_status: C.SCHEDULING_STATUS.SCHEDULED,
  });
};

const newDayOffRequestEvent = (startDate, endDate) => {
  return new CrewEventModel({
    startDate: startDate,
    endDate: endDate,
    phantom_group_key: EventHelperCommon.genPhantomGroupKey(),
    event_type: C.SCHEDULING_EVENT_TYPE.DAY_OFF_REQUEST,
    scheduling_status: C.SCHEDULING_STATUS.SCHEDULED,
    priority: C.DAY_OFF_REQUEST_PRIORITY.LOW,
  });
};

export default { newAshoreEvent, newDayOffRequestEvent };
